import styled, { css } from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "reducers/redux/data";
import { typography } from "globalConstants";
import { email as iconEmail } from "images";
import { ReduxStates } from "Types";
import { Data as DataType } from "Types/Reducers";

import AtomH2 from "Components/Atoms/H2";
import AtomPaper from "Components/Atoms/Paper";
import AtomButton from "Components/Atoms/Button";
import MoleculeFormText from "Components/Molecules/FormText";
import MoleculeFormSelect from "Components/Molecules/FormSelect";

export type PropsType = any;

const Wrap = styled(AtomPaper)`
   margin-top: 20px;
`;

const Text = styled.div<any>`
   ${typography.other.t8};
   margin-top: 9px;
   line-height: 22px;
   letter-spacing: -0.03em;
   ${({ css }) => css}
`;
const Purple = styled.span`
   color: ${typography.other.color.purple[0]};
   display: inline;
`;
const SubTitle = styled.span<any>`
   ${typography.other.t7}
   ${({ css }) => css}
`;

const Buttons = styled.div<any>`
   display: grid;
   width: 100%;
   grid-template-columns: 1fr 1fr;
   gap: 13px;
   ${({ css }) => css}
`;
const Button = styled(AtomButton)`
   ${typography.other.t6}
   grid-column: auto / span 1;
   border: 1px solid ${typography.other.color.gray[2]};
   background-color: white;
   color: black;
   box-sizing: border-box;
   width: 100%;
   ${({ css }) => css}
`;

const cssHighlight = css`
   background-color: black;
   border: null;
   color: white;
`;

const FormControlWrap = styled(MoleculeFormText.Wrap)``;

function EmailContainer() {
   const Wrap = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
   `;
   const Icon = styled.img`
      display: block;
      height: 12px;
   `;
   const Text = styled.div`
      ${typography.other.t6}
      margin-left: 12px;
      color: ${typography.other.color.gray[0]};
   `;

   return (
      <Wrap>
         <Icon src={iconEmail}></Icon>
         <Text>contact@art-map.co.kr</Text>
      </Wrap>
   );
}

export default function OrganismFormWithoutPassbook(props: PropsType) {
   const dispatch = useDispatch();
   const data = useSelector((state: any) => state.data);

   function dataSet(name: string, value: any) {
      dispatch({
         type: actions.set,
         payload: {
            ...data,
            [name]: value,
         },
      });
   }

   function dataOnChange(ev: any, target: string) {
      dataSet(target, ev.target.value);
   }

   // function paymentOnClick(type: typeof statuses[keyof typeof statuses]) {
   //    const action = type === statuses.card ? actions.setCard : type === statuses.phone ? actions.setPhone : type === statuses.withoutPassbook ? actions.setWithoutPassbook : null;

   //    console.log("call action", action);
   //    dispatch({
   //       type: action,
   //    });
   // }

   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <AtomH2>무통장 입금 확인사항</AtomH2>
         <Text
            css={css`
               margin-top: 23px;
            `}>
            <Purple>*</Purple>입금자명 : 신청자명과 송금인명 다를 시 꼭 기재 부탁드립니다.
            <br />
            문의사항은 아트맵 내 1:1 문의하기 또는 본 메일로
            <br />
            회신주시기 바랍니다. 감사합니다.
         </Text>
         <Text>
            <EmailContainer></EmailContainer>
         </Text>
         <FormControlWrap
            css={css`
               margin-top: 30px;
            `}>
            <MoleculeFormText.Label>입금자명</MoleculeFormText.Label>
            <MoleculeFormText.Text value={data.acount_holder} onChange={(ev: any) => dataOnChange(ev, "acount_holder")} placeholder="입금자명을 입력해주세요"></MoleculeFormText.Text>
         </FormControlWrap>
         <MoleculeFormSelect.Wrap>
            <MoleculeFormSelect.Label>입금은행</MoleculeFormSelect.Label>
            <MoleculeFormSelect.Select value={data.bank_name} onChange={(ev: any) => dataOnChange(ev, "bank_name")} placeholder="선택해 주세요">
               <option value="신한은행 110-566-597201">신한은행 110-566-597201 최선연(아트맵 코리아)</option>
            </MoleculeFormSelect.Select>
         </MoleculeFormSelect.Wrap>
         <SubTitle
            css={css`
               margin-top: 30px;
               display: block;
            `}>
            현금영수증 신청
         </SubTitle>
         <Buttons
            css={css`
               margin-top: 10px;
            `}>
            <Button css={data.should_cash_receipt === true ? cssHighlight : css``} onClick={() => dataSet("should_cash_receipt", true)}>
               신청
            </Button>
            <Button css={data.should_cash_receipt === false ? cssHighlight : css``} onClick={() => dataSet("should_cash_receipt", false)}>
               신청안함
            </Button>
         </Buttons>
      </Wrap>
   );
}
